import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { ZpcProxySettings, ZpmProxySettings } from '../../../shared/models/generated/ziroModels';
import { MicrosoftProxyFeatureSettingsResource } from '../../resources/microsoft-proxy-feature-settings.resource';
import { GlobalPropertiesContext } from '../../../shared/contexts/global-properties.context';
import { CiscoProxyFeatureSettingsResource } from '../../resources/cisco-proxy-feature-settings.resource';
import { Subscription } from 'rxjs';

export interface ZpmProxyFeatureSettingsEntity extends ZpmProxySettings {
  cucmPhoneNumberAssignmentMatchType: DidMatchType;
}

export interface ZpcProxyFeatureSettingsEntity extends ZpcProxySettings {
  teamsPhoneNumberAssignmentMatchType: DidMatchType;
}

export enum DidMatchType {
  END_MATCH = 'END_MATCH',
  EXACT_MATCH = 'EXACT_MATCH',
}

@Component({
  selector: 'ziro-proxy-feature-settings',
  templateUrl: './proxy-feature-settings.component.html',
  styleUrls: ['../../admin-page.scss'],
  standalone: false,
})
export class ProxyFeatureSettingsComponent implements OnInit, OnDestroy {
  private _breadcrumbsService = inject(BreadcrumbsService);
  private _microsoftProxyFeatureSettingsResource = inject(MicrosoftProxyFeatureSettingsResource);
  private globalPropertiesContext = inject(GlobalPropertiesContext);
  private _ciscoProxyFeatureSettingsResource = inject(CiscoProxyFeatureSettingsResource);

  isLoading = true;
  zpmProxyFeatureSettingsEntity: ZpmProxyFeatureSettingsEntity;
  zpcProxyFeatureSettingsEntity: ZpcProxyFeatureSettingsEntity;
  ziroIcons = ZiroIcons;
  isHostedEnabled = false;

  private _subs = new Subscription();

  ngOnInit(): void {
    const globalContextSub = this.globalPropertiesContext.state$.subscribe((globalProperties) => {
      this.isHostedEnabled = globalProperties.hostedEnabled;
      if (this.isHostedEnabled) {
        this._initZpmFormData();
      } else {
        this._initZpcFormData();
      }
    });

    this._breadcrumbsService.updateBreadcrumbs([
      { label: 'tkey;admin.proxy_server_management.title' },
      { label: 'tkey;admin.proxy_server_management.proxy_feature_settings.title' },
    ]);
    this._subs.add(globalContextSub);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  private _initZpmFormData(): void {
    const sub = this._microsoftProxyFeatureSettingsResource.get().subscribe((settings) => {
      this.zpmProxyFeatureSettingsEntity = {
        onPremAdWriteDownEnabled: settings.onPremAdWriteDownEnabled,
        cucmPhoneNumberAssignmentCheckEnabled: settings.cucmPhoneNumberAssignmentCheckEnabled,
        cucmPhoneNumberAssignmentMatchType:
          settings.cucmPhoneNumberAssignmentLastDigitsMatch > 0 ? DidMatchType.END_MATCH : DidMatchType.EXACT_MATCH,
        cucmPhoneNumberAssignmentLastDigitsMatch:
          settings.cucmPhoneNumberAssignmentLastDigitsMatch > 0
            ? settings.cucmPhoneNumberAssignmentLastDigitsMatch
            : undefined,
      };

      this.isLoading = false;
    });

    this._subs.add(sub);
  }

  private _initZpcFormData(): void {
    this._ciscoProxyFeatureSettingsResource.get().subscribe((settings) => {
      this.zpcProxyFeatureSettingsEntity = {
        teamsPhoneNumberAssignmentCheckEnabled: settings.teamsPhoneNumberAssignmentCheckEnabled,
        teamsPhoneNumberAssignmentMatchType:
          settings.teamsPhoneNumberAssignmentLastDigitsMatch > 0 ? DidMatchType.END_MATCH : DidMatchType.EXACT_MATCH,
        teamsPhoneNumberAssignmentLastDigitsMatch:
          settings.teamsPhoneNumberAssignmentLastDigitsMatch > 0
            ? settings.teamsPhoneNumberAssignmentLastDigitsMatch
            : undefined,
      };

      this.isLoading = false;
    });
  }
}
